module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "u-relative c-content-accordion u-pad-x-md u-pad-x-0@lg u-overflow-h u-pad-a-2 u-force-3d"
  }, [_c('header', {
    staticClass: "u-relative u-table u-fit-w u-height-xxl u-cursor-pointer",
    on: {
      "click": function($event) {
        _vm._toggleCollapsed()
      }
    }
  }, [_c('div', {
    staticClass: "u-table-cell u-valign-middle u-vacuum"
  }, [_c('h2', {
    staticClass: "u-inline-block u-valign-middle u-w15of16 t-text--bold t-text--lg"
  }, [_vm._v(_vm._s((_vm.index + 1) < 10 ? '0' + (_vm.index + 1) : (_vm.index + 1)) + " . " + _vm._s(_vm.part.title))]), _vm._v(" "), _c('div', {
    staticClass: "u-inline-block u-valign-middle u-w1of16 u-align-right"
  }, [_c('img', {
    staticClass: "u-w1of2 u-fit-w@md u-force-3d c-content-accordeon__img",
    class: [_vm.collapsed ? '' : 'c-content-accordeon__img--rotated'],
    attrs: {
      "src": require("../../../assets/icon/icon-arrow-down--outline.png"),
      "alt": "Toggle content"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "o-content u-pad-b-md",
    domProps: {
      "innerHTML": _vm._s(_vm.part.text)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-content-accordion__border-bottom u-absolute u-pos-bl u-fit-w u-height-2"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fc64085"}!./src/scripts/components/app-content-accordion/template.html
// module id = 890
// module chunks = 0